import React from "react";
import { CheckCircle, Sparkles, Home, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SuccessSubscription = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse animation-delay-2000" />
      </div>

      {/* Main content */}
      <div className="relative flex items-center justify-center min-h-screen p-4">
        <div className="max-w-2xl w-full">
          {/* Success card */}
          <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl p-8 md:p-12 border border-white/20">
            {/* Success icon */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-green-400 rounded-full blur-lg opacity-50" />
                <div className="relative bg-gradient-to-br from-green-400 to-emerald-500 rounded-full p-4">
                  <CheckCircle className="w-16 h-16 text-white" />
                </div>
              </div>
            </div>

            {/* Sparkles icon */}
            <div className="flex justify-center mb-6">
              <Sparkles className="w-8 h-8 text-yellow-400" />
            </div>

            {/* Success message */}
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
              Félicitations !
            </h1>

            <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6 text-gray-700">
              Votre abonnement est confirmé
            </h2>

            {/* Description */}
            <div className="space-y-4 mb-8 text-center">
              <p className="text-gray-600 text-lg">
                Merci de nous rejoindre ! Vous avez désormais accès à tous les
                avantages exclusifs de notre service .
              </p>

              <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 border border-indigo-100">
                <h3 className="font-semibold text-indigo-900 mb-2">
                  Ce qui vous attend :
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full mr-2" />
                    Accès illimité à toutes les fonctionnalités
                  </li>
                  <li className="flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full mr-2" />
                    Support prioritaire 24/7
                  </li>
                  <li className="flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full mr-2" />
                    Contenus exclusifs chaque semaine
                  </li>
                </ul>
              </div>
            </div>

            {/* Redirect button */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate("/cfp/subscription")}
                className="group inline-flex items-center justify-center px-8 py-4 bg-white text-indigo-600 font-semibold rounded-2xl border-2 border-indigo-200 hover:border-indigo-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
              >
                Accéder à mon espace
              </button>
            </div>

            {/* Additional info */}
            <p className="text-center mt-6 text-sm text-gray-500">
              Un email de confirmation vous a été envoyé avec tous les détails.
            </p>
          </div>

          {/* Decorative dots */}
          <div className="flex justify-center mt-8 space-x-2">
            <div
              className="w-2 h-2 bg-indigo-300 rounded-full animate-bounce"
              style={{ animationDelay: "0s" }}
            />
            <div
              className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce"
              style={{ animationDelay: "0.1s" }}
            />
            <div
              className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
              style={{ animationDelay: "0.2s" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessSubscription;
